import { apiFetch } from './client';

export interface AdminUserRow {
  userId: string;
  email: string;
  name: string;
  tenants: { tenantId: string; role: string }[];
  plan: string;
  bypassBilling: boolean;
  discountPct: number | null;
  lastSeenAt: string | null;
}

export async function adminListUsers(params?: { q?: string; limit?: number }): Promise<{
  users: AdminUserRow[];
  nextCursor: string | null;
}> {
  const sp = new URLSearchParams();
  if (params?.q) sp.set('q', params.q);
  if (params?.limit) sp.set('limit', String(params.limit));
  const suffix = sp.toString() ? `?${sp.toString()}` : '';
  return apiFetch(`/admin/users${suffix}`);
}

export async function adminGetUser(userId: string): Promise<Record<string, unknown>> {
  return apiFetch(`/admin/users/${encodeURIComponent(userId)}`);
}

export async function adminToggleBypass(userId: string, reason: string): Promise<void> {
  await apiFetch(`/admin/users/${encodeURIComponent(userId)}/override-bypass`, {
    method: 'POST',
    body: { reason },
  });
}

export async function adminSetDiscount(
  userId: string,
  pct: number | null,
  reason: string,
): Promise<void> {
  await apiFetch(`/admin/users/${encodeURIComponent(userId)}/override-discount`, {
    method: 'POST',
    body: { pct, reason },
  });
}

export async function adminUserAudit(userId: string): Promise<{ entries: unknown[] }> {
  return apiFetch(`/admin/users/${encodeURIComponent(userId)}/audit`);
}

export async function adminFlagsList(): Promise<{
  flags: Array<Record<string, unknown> & { name: string }>;
}> {
  return apiFetch('/admin/flags');
}

export async function putFlag(
  name: string,
  body: {
    reason: string;
    enabled?: boolean;
    auto_rollback?: boolean;
    default_for_role?: Partial<Record<'admin' | 'tenant_admin' | 'pt' | 'client', boolean>>;
  },
): Promise<unknown> {
  return apiFetch(`/flags/${encodeURIComponent(name)}`, {
    method: 'PUT',
    body,
  });
}
